<nav class="navbar navbar-expand-lg navbar-light">
    <a class="navbar-brand logo" href="#">
        <img src="../../../assets/images/rapidjpg.png" class="img-fluid"/>
      Play Online Delhi
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
     
      <ul class="navbar-nav ml-auto"> 

        <li class="nav-item active">
          <a class="nav-link" href="/">Home <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#result">Results</a>
        </li>
        
        <li class="nav-item">
          <a class="nav-link" href="#about">About</a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link btn btn-outline-primary" href="#"><img src="../../../assets/images/playstore.png" class="img-fluid icon"> Download</a>
        </li> -->
      </ul>
      <!-- <form class="form-inline my-2 my-lg-0">
        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
        <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
      </form> -->
    </div>
  </nav>